import { StockProfileEndpoints } from '@/modules/seller-management/stock-profile/api/stockProfileEndpoints'

/**
 * Stock Profile endpoint instance
 * instantiate Stock Profile api class with different api path
 */

export const stockProfileEndpoints = new StockProfileEndpoints()
